<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Appraisal Credits</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay"
              item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>Sort Order</b></p>
            <v-text-field outlined dense type="number" v-model="sortorder"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>Credit</b></p>
            <v-text-field outlined dense type="text" v-model="credit"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>Credit Point</b></p>
            <v-text-field outlined dense type="number" v-model="credit_point"></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="center" dense>
          <v-col sm="4" md="4">
            <p><b>Criteria</b></p>
            <v-textarea outlined name="input-7-4" v-model="criteria" label="Enter Criteria"></v-textarea>
          </v-col>
        </v-row>
        <v-row justify="center" dense v-if="ay && sortorder && credit_point && credit && criteria">
          <v-btn color="warning" @click="saveCredit()">Save</v-btn>
        </v-row>
      </v-card>


      <v-card class="box" v-if="filteredCreditList !=''">
        <v-data-table :headers="headers" :items="filteredCreditList">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Appraisal Credit List</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.isactive`]="{ item }">
            <span v-if="item.isactive">
              <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
            </span>
            <span v-else>
              <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
            </span>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <v-icon class="mr-2 v-icon-size" @click="editCredit(item)" color="success">mdi-pencil</v-icon>
          </template>
          <template v-slot:[`item.toggle`]="{ item }">
            <v-switch v-model="item.isactive" @change="saveUpdateCreditIsctive(item)"></v-switch>
          </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="dialog_edit" persistent scrollable="false" max-width="1200px"
        transition="dialog-bottom-transition">
        <v-card class="box">
          <v-toolbar flat class="toolbar">
            <v-toolbar-title>Edit Appraisal Credit</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-row justify="center" dense>
              <v-col cols="12" sm="3">
                <p><b>Sort Order</b></p>
                <v-text-field type="number" outlined dense v-model="editedItem.sortorder"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>Credit</b></p>
                <v-text-field outlined dense v-model="editedItem.credit"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>Credit Point</b></p>
                <v-text-field type="number" outlined dense v-model="editedItem.credit_point"></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center" dense>
              <v-col cols="12" sm="3">
                <p><b>Credit Criteria</b></p>
                <v-textarea outlined name="input-7-4" v-model="editedItem.criteria" label="Enter Criteria"></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <br />
          <v-row justify="center">
            <v-btn color="primary" :loading="loader" @click="saveEditCredit()">Update</v-btn>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" @click="dialog_edit = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
    data: () => ({
      loader:false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
    overlay: false,
    // extraBreadcrumbItems: [
    //   { text: "Appraisal Credit", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style1",
      criteria:"",
      ay_list:[],ay:null,credit_point:"",credit:"",criteria:"",appraisal_credit_list:[],dialog_edit:false,sortorder:"",
      headers:[
      { text: "Sr No", value: "count" },
      { text: "Sort Order", value: "sort_order" },
      { text: "Credit", value: "credit" },
      { text: "Credit Point", value: "credit_point" },
      { text: "Credit Criteria", value: "criteria" },
      { text: "Academic Year", value: "academicyear" },
      { text: "Active", value: "isactive" },
      { text: "Edit", value: "edit" },
      { text: "Mark Active/Inactive", value: "toggle" },
      ],
      editedItem: {
      id: "",
      credit: "",
      credit_point: "",
      criteria: "",
      sortorder:""
    },
  }),
   methods: {
    saveUpdateCreditIsctive(item){
    const data = {
        appraisal_credit_id: item.id,
        isactive: item.isactive,
      };
      this.overlay = true;
      axios
        .post("/SelfAppriasalMaster/saveUpdateCreditIsactive", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.appraisal_credit_list = res.data.appraisal_credit_list)
            this.showSnackbar("green", "Updated Successfully...");
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    saveEditCredit(){
      this.overlay = true;
      this.loader = true;
      axios
        .post("/SelfAppriasalMaster/saveEditCredit", this.editedItem)
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.appraisal_credit_list = res.data.appraisal_credit_list)
            this.dialog_edit = false;
            this.showSnackbar("green", "Details Updated Successfully...");
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader = false;
        });
    },
    editCredit(item){
      this.editedItem.id=item.id
      this.editedItem.credit=item.credit
      this.editedItem.credit_point=item.credit_point
      this.editedItem.criteria=item.criteria
      this.editedItem.sortorder=item.sort_order
      this.dialog_edit=true
    },
    clearData(){
      this.credit=""
      this.credit_point=""
      this.criteria=""
      this.sortorder=""
    },
    saveCredit(){
      const data = {
        ay: this.ay,
        credit: this.credit,
        credit_point: this.credit_point,
        criteria: this.criteria,
        sortorder:this.sortorder
      };
      this.overlay = true;
      this.loader = true;
      axios
        .post("/SelfAppriasalMaster/saveCredit", data)
        .then((res) => {
          if (res.data.flag == "YES") {
           (this.appraisal_credit_list = res.data.appraisal_credit_list)
           this.clearData();
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          //this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader = false;
        });
    },
     onLoad() {
        axios
            .post("SelfAppriasalMaster/appraisalCredit")
            .then((res) => {
                if (res.data.flag == "YES") {
                    (this.ay_list = res.data.ay_list),
                    (this.appraisal_credit_list = res.data.appraisal_credit_list),
                     (this.ay = res.data.current_ay);
                    this.overlay = false;
                } else {
                    this.showSnackbar("#b71c1c", res.data.status_reason);
                }
            })
            .catch((error) => {
                this.showSnackbar("#b71c1c", "Something went wrong!!!");
                this.overlay = false;
            })
            .finally(() => {
                this.overlay = false;
            });
            },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
    this.onLoad();
  },
  computed: {
    filteredCreditList() {
        let filteredList = this.appraisal_credit_list;
        if (this.ay) {
            filteredList = this.appraisal_credit_list.filter(ay => ay.academicyear_id === Number(this.ay));
        }
        return filteredList; // ✅ RETURN the filtered list
    }
},
  watch: {},
};
</script>
<style scoped>
</style>